import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-layout')
export class MdcLayout extends LitElement {
  @property({ type: Boolean, attribute: 'is-open' }) isOpen = true

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-layout {
			display: flex;
			width: 100%;
			height: 100vh;
			flex-direction: row;
			position: relative;
		}

		.mdc-layout__sidenav {
			flex: 0 0 280px;
			background-color: var(--color-background-primary, var(--color-functional-gray-white));
			border-right: 1px solid var(--color-border-primary, var(--color-functional-gray-75));
			transition: transform 0.3s ease-in-out;
			transition-delay: 0.1s;
			position: relative;
			z-index: 2;
			box-sizing: border-box;
		}

		.mdc-layout__content {
			flex: 1 1 auto;
			position: relative;
			overflow-y: auto;
			min-width: 0;
			height: 100%;
			max-height: 100%;
		}

		.mdc-layout__content-inner {
			overflow-y: auto;
			padding: var(--spacing-100, 1rem);
		}

		.mdc-sidenav__toggle {
			display: none;
			align-items: center;
			justify-content: center;
			width: 2.5rem;
			height: 2.5rem;
			color: var(--color-foreground-secondary, var(--color-functional-gray-400));
			transition: color 0.2s ease-in-out;
			margin-bottom: var(--spacing-100, 1rem);
			gap: var(--spacing-025, 0.25rem);
			border: none;
			background: none;
			cursor: pointer;
			padding: 0;
		}

		.mdc-sidenav__toggle:hover {
			color: var(--color-foreground-primary, var(--color-functional-gray-black));
		}

		.mdc-sidenav__toggle:focus-visible {
			box-shadow: 0 0 0 2px var(--color-functional-blue-300);
			outline: none;
		}

		.mdc-sidenav__overlay {
			display: none;
			position: fixed;
			left: 0;
			width: 100svw;
			height: 100%;
			background-color: var(--color-background-overlay, rgba(17, 17, 17, 0.5));
			opacity: 0;
			visibility: hidden;
			transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
			z-index: 1;
		}

		.mdc-layout__content .mdc-breadcrumb {
			padding: var(--spacing-100, 1rem);
			display: none;
		}

		/* breakpoints.lg - 1 */
		@media (max-width: 1023px) {
			.mdc-layout {
				display: block;
			}

			.mdc-layout.mdc-layout--sidenav-open .mdc-sidenav__overlay {
				display: block;
				opacity: 1;
				visibility: visible;
			}

			.mdc-layout.mdc-layout--sidenav-open .mdc-layout__sidenav {
				transform: translateX(0);
			}

			.mdc-layout__content .mdc-breadcrumb {
				display: flex;
			}

			.mdc-sidenav__toggle {
				display: flex;
			}
		}
	`

  render() {
    const layoutClasses = `mdc-layout${this.isOpen ? ' mdc-layout--sidenav-open' : ''}`
    const sidenavClasses = `mdc-layout__sidenav${this.isOpen ? ' mdc-layout__sidenav--open' : ''}`
    const overlayClasses = `mdc-sidenav__overlay${this.isOpen ? ' mdc-sidenav__overlay--visible' : ''}`

    return html`
			<div class=${layoutClasses}>
				<div class=${sidenavClasses}>
					<div class=${overlayClasses}></div>
					<slot name="sidenav"></slot>
				</div>
				<div class="mdc-layout__content">
					<div class="mdc-layout__content-inner">
						<button type="button" class="mdc-sidenav__toggle" aria-label="Toggle navigation">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								aria-hidden="true"
							>
								<path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</button>
						<slot></slot>
					</div>
				</div>
			</div>
		`
  }
}
